export default __webpack_public_path__ + "static/media/Highlord's Krys.6fb88a50.jpg";